export default {
  "정기안전보건" : `○ 산업안전 및 사고 예방에 관한 사항
○ 산업보건 및 직업병 예방에 관한 사항
○ 위험성 평가에 관한 사항
○ 건강증진 및 질병 예방에 관한 사항
○ 유해ㆍ위험 작업환경 관리에 관한 사항
○ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항
○ 직무스트레스 예방 및 관리에 관한 사항
○ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항`,


  "관리감독자교육": `○ 산업안전 및 사고 예방에 관한 사항
○ 산업보건 및 직업병 예방에 관한 사항
○ 위험성평가에 관한 사항
○ 유해ㆍ위험 작업환경 관리에 관한 사항
○ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항
○ 직무스트레스 예방 및 관리에 관한 사항
○ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항
○ 작업공정의 유해ㆍ위험과 재해 예방대책에 관한 사항
○ 사업장 내 안전보건관리체제 및 안전ㆍ보건조치 현황에 관한 사항
○ 표준안전 작업방법 결정 및 지도ㆍ감독 요령에 관한 사항
○ 현장근로자와의 의사소통능력 및 강의능력 등 안전보건교육 능력 배양에 관한 사항
○ 비상시 또는 재해 발생 시 긴급조치에 관한 사항
○ 그 밖의 관리감독자의 직무에 관한 사항`,


  "환경교육직무보수교육": ``,


  "외부업체교육": ``,


  "특별안전보건": ``,


  "신입사원교육": `○ 산업안전 및 사고 예방에 관한 사항
○ 산업보건 및 직업병 예방에 관한 사항
○ 위험성 평가에 관한 사항
○ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항
○ 직무스트레스 예방 및 관리에 관한 사항
○ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항
○ 기계ㆍ기구의 위험성과 작업의 순서 및 동선에 관한 사항
○ 작업 개시 전 점검에 관한 사항
○ 정리정돈 및 청소에 관한 사항
○ 사고 발생 시 긴급조치에 관한 사항
○ 물질안전보건자료에 관한 사항`,


  "직무전환교육": `○ 산업안전 및 사고 예방에 관한 사항
○ 산업보건 및 직업병 예방에 관한 사항
○ 위험성 평가에 관한 사항
○ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항
○ 직무스트레스 예방 및 관리에 관한 사항
○ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항
○ 기계ㆍ기구의 위험성과 작업의 순서 및 동선에 관한 사항
○ 작업 개시 전 점검에 관한 사항
○ 정리정돈 및 청소에 관한 사항
○ 사고 발생 시 긴급조치에 관한 사항
○ 물질안전보건자료에 관한 사항`,


  "TQM교육": ``,


  "소방교육": ``,
}
